import { render, staticRenderFns } from "./El_together.vue?vue&type=template&id=14dcefd8&scoped=true"
import script from "./El_together.vue?vue&type=script&lang=js"
export * from "./El_together.vue?vue&type=script&lang=js"
import style0 from "./El_together.vue?vue&type=style&index=0&id=14dcefd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dcefd8",
  null
  
)

export default component.exports